import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FileText, Eye, Upload } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const DOC_LIST = [
  { key: 'driver_id', label: 'Driver ID Copy' },
  { key: 'drivers_license', label: 'Drivers License' },
  { key: 'owner_id', label: 'Owner ID Copy' },
  { key: 'enatis', label: 'eNatis Document' },
  { key: 'vehicle_images', label: 'Vehicle Images' },
  { key: 'tracker_certificate', label: 'Tracker Certificate' },
  { key: 'license_disc', label: 'License Disc' },
  { key: 'page_28', label: 'Page 28' },
  { key: 'criminal_checks', label: 'Criminal Checks' },
];

export const DocsDialog = ({ open, onOpenChange, docsDriver, driverDocs, uploadingDoc, onUpload }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-emerald-600" />
          Documents - {docsDriver?.driver_name}
        </DialogTitle>
        <DialogDescription>
          Upload and view documents for this driver. Click Upload to add a file, View to open it.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-4">
        {DOC_LIST.map(doc => {
          const docInfo = driverDocs[doc.key] || {};
          const hasFile = docInfo.has_file;
          const driverId = docsDriver?.id;
          return (
            <div key={doc.key} className="flex items-center justify-between p-3 rounded-lg border bg-white hover:bg-slate-50">
              <div className="flex items-center gap-3">
                <FileText className={`h-5 w-5 ${hasFile ? 'text-emerald-600' : 'text-slate-400'}`} />
                <div>
                  <p className="font-medium text-sm">{doc.label}</p>
                  <p className="text-xs text-slate-500">
                    {hasFile ? `Uploaded: ${docInfo.filename}` : (docInfo.status || 'No file uploaded')}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                {hasFile && (
                  <a
                    href={`${API_URL}${docInfo.url}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  >
                    <Eye className="h-3 w-3" /> View
                  </a>
                )}
                <label className={`inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md cursor-pointer ${uploadingDoc === doc.key ? 'bg-slate-400' : 'bg-emerald-500 hover:bg-emerald-600'} text-white`}>
                  <Upload className="h-3 w-3" />
                  {uploadingDoc === doc.key ? 'Uploading...' : 'Upload'}
                  <input
                    type="file"
                    className="hidden"
                    accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                    disabled={uploadingDoc === doc.key}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file && driverId) onUpload(driverId, doc.key, file);
                      e.target.value = '';
                    }}
                  />
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
